document.addEventListener("DOMContentLoaded", () => {
  const shareBtn = document.querySelector(".product-share-btn");
  const copyBtn = document.querySelector(".product-copy-btn");

  function handleShare(e) {
    e.preventDefault();
    e.stopPropagation();
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .catch((err) => {
          // User cancelled or error — fallback to copy
          if (err.name !== "AbortError") {
            copyLinkToClipboard();
          }
        });
    } else {
      copyLinkToClipboard();
    }
  }

  function handleCopy(e) {
    e.preventDefault();
    e.stopPropagation();
    copyLinkToClipboard();
  }

  if (shareBtn) {
    shareBtn.addEventListener("click", handleShare);
    shareBtn.addEventListener("touchend", handleShare);
  }

  if (copyBtn) {
    copyBtn.addEventListener("click", handleCopy);
    copyBtn.addEventListener("touchend", handleCopy);
  }

  function copyLinkToClipboard() {
    var url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          showCopyFeedback();
        })
        .catch(() => {
          fallbackCopy(url);
        });
    } else {
      fallbackCopy(url);
    }
  }

  function fallbackCopy(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      showCopyFeedback();
    } catch (err) {
      alert("Link: " + text);
    }
    document.body.removeChild(textArea);
  }

  function showCopyFeedback() {
    var btn = copyBtn || shareBtn;
    if (btn) {
      var original = btn.innerHTML;
      btn.innerHTML =
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      setTimeout(function () {
        btn.innerHTML = original;
      }, 1500);
    }
  }
});
